import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import usePrevious from 'Hooks/usePrevious';

export default function usePreventScroll() {
  const { pathname } = useLocation();
  const [positionY, setPositionY] = useState();
  const [scroll, setScroll] = useState();
  const prevUrl = usePrevious({ pathname });

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (scroll) {
      setPositionY(window.scrollY);
    }

    if (!scroll && positionY) {
      setPositionY();
    }

    if (scroll && positionY && prevUrl && prevUrl.pathname !== pathname) {
      window.scrollTo({ top: positionY });
    }
  });

  return setScroll;
}
